
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { EpisodeForm } from "./EpisodeForm";
import { EpisodeWithCategory, EpisodeCategory } from "./types";

interface EpisodeEditDialogProps {
  episode: EpisodeWithCategory | null;
  categories: EpisodeCategory[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (episode: any) => Promise<void>;
  saving?: boolean;
}

export const EpisodeEditDialog = ({ 
  episode, 
  categories,
  open, 
  onOpenChange, 
  onSave,
  saving 
}: EpisodeEditDialogProps) => {
  const handleSave = async (episodeData: any) => {
    await onSave(episodeData);
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {episode ? "Edit Episode" : "Create New Episode"}
          </DialogTitle>
        </DialogHeader>
        <EpisodeForm
          episode={episode || undefined}
          categories={categories}
          onSave={handleSave}
          onCancel={handleCancel}
          saving={saving}
        />
      </DialogContent>
    </Dialog>
  );
};
